export const ListTableManagement = () => {
  const listItem = [];
  return listItem;
};
